import React from 'react';
import {ISpecificSafezoneObject} from "./safezone-object-factory.service.interface";
import {
  CHANNEL,
  CLOSE_SAFEZONE_SOURCE_VALUES,
  IFullSafezoneHandler, IOpenFullSafezoneParams,
  OPEN_SAFEZONE_SOURCE_VALUES,
  SAFEZONE_CONTAINERS_ID,
  SAFEZONE_EVENTS, SafeZoneDeeplink
} from "./safezone.service.interface";
import {FullSafezoneComponent} from "../../components/safezone/full-safezone.component";
import SafezoneHandlerBase from "./safezone-handler-base";


export class FullSafezoneHandler extends SafezoneHandlerBase implements IFullSafezoneHandler {
  protected _category:string = SAFEZONE_EVENTS.CATEGORY_FULL;
  protected _openEventName:string = SAFEZONE_EVENTS.FULL_OPEN;
  protected _readyEventName:string = SAFEZONE_EVENTS.FULL_READY;
  protected _closeEventName:string = SAFEZONE_EVENTS.FULL_CLOSE_EXTERNAL;
  protected _channel:CHANNEL;
  protected _containerId: SAFEZONE_CONTAINERS_ID = SAFEZONE_CONTAINERS_ID.FULL_SAFEZONE_CONTAINER_ID;

  private _isOpen:boolean = false;
  closedFromSafezone = false;

  init(safezoneObj:ISpecificSafezoneObject):void{
    super.init(safezoneObj);

    if(this._isOpen){
      this._channel = CHANNEL.LOBBY;
      this._renderSafezone(OPEN_SAFEZONE_SOURCE_VALUES.LOBBY);
    }
  }

  public openFullSafezone(params?: IOpenFullSafezoneParams): void {
    if(params?.correlationId){
      this._correlationId = params?.correlationId;
    }
    const source = params?.source ? params?.source : OPEN_SAFEZONE_SOURCE_VALUES.LOBBY;
    this._openFullSafezoneFromSource(source, params?.safeZoneDeeplink);
  }

  private _openFullSafezoneFromSource(source:OPEN_SAFEZONE_SOURCE_VALUES, safeZoneDeeplink?: SafeZoneDeeplink){
    this._services.drawer.right.push({
      render: () => <FullSafezoneComponent onRender={() => this._onFullSafezoneRender(source, safeZoneDeeplink)}/>,
      onClose: () => {
        this._isOpen = false;
        this._closeSafezone(CLOSE_SAFEZONE_SOURCE_VALUES.CLIENT);
      }
    });
  }

  protected _sendCloseEvent(){
    // when full was closed from inside safezone e.g. close button action, we don't have to send close event, because is send by safezone
    if(this.closedFromSafezone){
      return;
    }
    super._sendCloseEvent();
  }

  private _onFullSafezoneRender(source: OPEN_SAFEZONE_SOURCE_VALUES, safeZoneDeeplink?: SafeZoneDeeplink) {
    this._isOpen = true;
    this.closedFromSafezone = false;
    if (source === OPEN_SAFEZONE_SOURCE_VALUES.USER_AREA){
      this._channel = CHANNEL.MINI;
      this._renderSafezone(source, this._correlationId, safeZoneDeeplink);
    } else {
      this._channel = CHANNEL.LOBBY;
      this._renderSafezone(source, undefined, safeZoneDeeplink);
    }
  }
}